// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton[data-v-1fcac8ab]:disabled {\n  cursor: not-allowed\n}\n.area-code[data-v-1fcac8ab] {\n  border-radius: 3px;\n  padding: 1px;\n  border: 1px solid #ebebeb;\n}\n", ""]);
// Exports
module.exports = exports;
